import {
    GetMainPageRequestWithDefaults,
    MainPageData,
    useActualContentQuery,
    useMainPageCourseContainersQuery,
    useMainPageQuery,
} from 'platform-components/src/queries/use-main-page-query';
import { QueryConfig } from 'react-query';
import { useSelector } from 'react-redux';
import { getIsPublicShowcase } from 'common.components/user/selectors';
import { GetMainPageRequest } from '@yandex-int/k-common/client/api/defs/get-main-page';

export function useTeacherMainPage(
    queryParams: GetMainPageRequestWithDefaults,
    queryConfig: QueryConfig<MainPageData> = {}
) {
    const isPublicShowCase = useSelector(getIsPublicShowcase);
    return useMainPageQuery({ is_public_blocks: isPublicShowCase, ...queryParams }, queryConfig);
}

export function useTeacherActualContentQuery(queryParams: GetMainPageRequest, queryConfig?: QueryConfig<MainPageData>) {
    const isPublicShowCase = useSelector(getIsPublicShowcase);
    return useActualContentQuery({ is_public_blocks: isPublicShowCase, ...queryParams }, queryConfig);
}

export function useTeacherMainPageCourseContainersQuery(
    queryParams: GetMainPageRequestWithDefaults,
    queryConfig?: QueryConfig<MainPageData>
) {
    const isPublicShowCase = useSelector(getIsPublicShowcase);
    return useMainPageCourseContainersQuery({ is_public_blocks: isPublicShowCase, ...queryParams }, queryConfig);
}
